function initBfSlider(slider) {
  if (slider.hasAttribute('data-bf-slider-ready')) return;
  slider.setAttribute('data-bf-slider-ready', '');

  var scroller = slider.querySelector('[data-bf-slider-scroller]');
  var controls = slider.querySelector('[data-bf-slider-controls]');
  var prev = slider.querySelector('[data-bf-slider-prev]');
  var next = slider.querySelector('[data-bf-slider-next]');
  var bar = slider.querySelector('[data-bf-slider-bar]');
  var thumb = slider.querySelector('[data-bf-slider-thumb]');
  if (!scroller || !controls || !prev || !next || !thumb) return;

  function maxScroll() {
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  function step() {
    var card = scroller.firstElementChild;
    if (!card) return scroller.clientWidth * 0.8;
    var styles = window.getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function sync() {
    var max = maxScroll();
    var overflow = max > 2;
    controls.hidden = !overflow;
    slider.classList.toggle('is-scrollable', overflow);
    if (!overflow) return;

    var ratio = max === 0 ? 0 : scroller.scrollLeft / max;
    var thumbWidth = Math.max(18, (scroller.clientWidth / scroller.scrollWidth) * 100);
    var travel = 100 - thumbWidth;
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = ratio * travel + '%';
    if (bar) bar.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    prev.disabled = scroller.scrollLeft <= 2;
    next.disabled = scroller.scrollLeft >= max - 2;
  }

  prev.addEventListener('click', function () {
    scroller.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  next.addEventListener('click', function () {
    scroller.scrollBy({ left: step(), behavior: 'smooth' });
  });

  scroller.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);

  if (bar) {
    bar.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      var max = maxScroll();
      if (max <= 0) return;
      var rect = bar.getBoundingClientRect();
      var thumbWidth = Math.max(18, (scroller.clientWidth / scroller.scrollWidth) * 100);
      var travel = Math.max(1, 100 - thumbWidth);

      function setFromClientX(clientX) {
        var x = Math.min(Math.max(0, clientX - rect.left), rect.width);
        var centerRatio = (x / rect.width) * 100;
        var ratio = Math.min(Math.max(0, (centerRatio - thumbWidth / 2) / travel), 1);
        scroller.scrollLeft = ratio * max;
      }

      setFromClientX(event.clientX);
      bar.setPointerCapture(event.pointerId);
      function onMove(e) { setFromClientX(e.clientX); }
      function onUp() {
        bar.releasePointerCapture(event.pointerId);
        bar.removeEventListener('pointermove', onMove);
        bar.removeEventListener('pointerup', onUp);
      }
      bar.addEventListener('pointermove', onMove);
      bar.addEventListener('pointerup', onUp);
    });
  }

  slider._bfSync = sync;
  sync();
}

document.querySelectorAll('[data-bf-slider]').forEach(initBfSlider);
